import { getRestService } from '../restClient';
import { getService } from './service';

function bufferToBlob(buffer, mime) {
  return new Blob([buffer], { type: mime });
}

// Types: Event, Person, Warrants, Address, FIREARM, ITEM, JEWELRY, STRUCTURE, SUBSTANCE, 
// EVIDENCE, INCIDENTPERSON, INCIDENTPROPERTY, VEHICLE, 
export const uploadAttachment = (id, file, type = 'Event', descr = '', codeAttachmentType) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    try {
      reader.onload = async function () {
        try {
          const service = getService('cad-attachments');
          const result = await service.create({
            parentType: type,
            ptsParentID: id,
            fileName: file.name,
            fileType: file.name.split('.')[1],
            data: reader.result.split(',')[1],
            description: descr,
            codeAttachmentType: codeAttachmentType,
          });
          resolve(result);
        } catch (err) {
          reject(err);
        }
      };
    } catch (err) {
      reject(err);
    }
  });
};

export const uploadAttachments = async (attachments = []) => {
  if (!attachments || attachments.length === 0) return [];

  const response = await Promise.all(
    attachments.map((att) =>
      uploadFormDataAttachments(
        att.parentId,
        att.file,
        att.fileName,
        att.parentType,
        att.descr || '',
        att.user,
        att.codeAttachmentType,
        att.clearanceLevel ?? 0
      )
    )
  );

  return response;
};
export const uploadFormDataAttachments = async (
  parentId,
  file,
  fileName,
  parentType,
  descr = '',
  user,
  codeAttachmentType,
  clearanceLevel
) => {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append('ptsParentID', parentId);
    formData.append('file', file);
    formData.append('fileName', fileName);
    formData.append('fileType', fileName.split('.').pop());
    formData.append('parentType', parentType);
    formData.append('description', descr);
    formData.append('CreatedBy', user);
    formData.append('UpdatedBy', user);
    formData.append('codeAttachmentType', codeAttachmentType);
    formData.append('clearanceLevel', clearanceLevel);
    const service = getRestService('rms-attachments');
    try {
      const response = await service.create(formData);
      resolve(response);
    } catch (err) {
      reject(err);
    }
  });
};

export const uploadCADAttachment = async (attachments = []) => {
  if (!attachments.length) return [];

  const service = getRestService('cad-attachments');
  return Promise.all(
    attachments.map((att) => {
      const file = att.fileObject?.file || att.file;
      const fileName = att.fileName || att.fileObject?.name;
      const fileType = fileName?.split('.').pop();

      const formData = new FormData();
      formData.append('ptsParentID', att.parentId);
      formData.append('file', file);
      formData.append('fileName', fileName);
      formData.append('fileType', fileType);
      formData.append('parentType', att.parentType);
      formData.append('description', att.descr || att.fileObject?.description || '');
      formData.append('CreatedBy', att.user);
      formData.append('UpdatedBy', att.user);
      formData.append(
        'codeAttachmentType',
        att.codeAttachmentType || att.fileObject?.codeAttachmentType
      );
      return service.create(formData);
    })
  );
};

export const uploadPersonPhoto = (data) => {
  const { file, ptsPersonID, ImageTypeCode, IsMark, Location, Gang, Description, MarkType } = data;
  const { name } = file;
  const fileName = name ? file.name.substring(0, 49) : 'Snapshot';
  const fileType = name ? file.name.split('.')[1] : 'png';
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    try {
      reader.onload = async function () {
        const service = getService('cad-upload-person-photo');
        const result = await service.create({
          ptsPersonID,
          ImageTypeCode,
          IsMark,
          Location,
          Gang,
          MarkType,
          Description,
          fileName,
          fileType,
          data: reader.result.split(',')[1],
        });
        resolve(result);
      };
    } catch (err) {
      reject(err);
    }
  });
};

export const downloadPersonPhoto = (id, name) => {
  return new Promise((resolve, reject) => {
    const service = getService('cad-upload-person-photo');
    service
      .get(id)
      .then((res) => {
        const blob = bufferToBlob(res.buffer, res.type);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        link.click();
        return resolve();
      })
      .catch(reject);
  });
};

export const downloadAttachment = (id, name) => {
  return new Promise((resolve, reject) => {
    const service = getService('cad-attachments');
    service
      .get(id)
      .then((res) => {
        const blob = bufferToBlob(res.buffer, res.type);
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = name;
        link.click();
        return resolve();
      })
      .catch(reject);
  });
};

export const removeAttachment = (id) => {
  const service = getService('cad-attachments');
  return service.remove(id);
};

export const findAttachments = (type, id) => {
  const service = getService('cad-attachments');
  return service.find({ query: { ParentType: type, ptsParentID: id } });
};

export const updateAttachment = (data) => {
  const service = getService('cad-attachments');
  return service.patch(data.ptsAttachmentID, data);
};

export const getAttachmentById = (ptsAttachmentID) => {
  const service = getService('cad-attachments');
  return service.get(ptsAttachmentID);
};

export const mimeMap = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  bmp: 'image/bmp',
};

export const downloadBufferAttachment = (buffer, FileType, FileName) => {
  if (!buffer) return;
  const mimeType = mimeMap[FileType.toLowerCase()] || 'application/octet-stream';
  const blob = new Blob([buffer], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${FileName}.${FileType}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const arrayBufferToBase64 = (arrayBuffer) => {
  if (!arrayBuffer) return '';

  let binary = '';
  const bytes = new Uint8Array(arrayBuffer);
  let len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const getFileURLFromBuffer = (arrayBuffer, FileType) => {
  const base64 = arrayBufferToBase64(arrayBuffer);
  const fileUrl = `data:${FileType};base64,${base64}`;
  return fileUrl;
};
